<template>
	<div id="compatibility-devices">

		<div class="row justify-content-center">
			<div class="text-center">
				<h5 class="tab-title">Dispositivos compatibles</h5>
				<p>
					Te compartimos una lista de los dispositivos compatibles en caso de que no encuentres tu IMEI.
				</p>
			</div>
		</div>

		<div class="row justify-content-center mt-3">
			<b-form-group class="col-md-6 custom-f-group" 
				:label="b.name" v-for="(b, bInx) in brands"
				:key="'bInx-' + bInx">
				<b-form-select v-model="phones">
					<b-form-select-option :value="null">Dispositivos {{ b.name }}</b-form-select-option>
					<b-form-select-option value="a" disabled v-for="(d, dInx) in b.devicesOpts"
						:key="'dInx' + dInx + bInx">
						{{ d }}
					</b-form-select-option>
				</b-form-select>
			</b-form-group>
		</div>

	</div>
</template>

<script>
export default {
	name: 'compatibilityDevices',
	data() {
		return {
			phones: null,

			brands: [
				{
					name: 'Alcatel', devicesOpts: [
						'1', '1S', '3', '3V'
					]
				},
				{
					name: 'Apple', devicesOpts: [
						'Iphone 7', 'Iphone 7 Plus', 'Iphone 8', 'Iphone 8 Plus', 'Iphone X', 'Iphone XR', 'Iphone XS', 'Iphone XS Max', 'Iphone 11', 'Iphone 11 Pro', 'Iphone 11 Pro Max'
					]
				},
				{
					name: 'Huawei', devicesOpts: [
						'Y5 NEO', 'Y5 2018', 'Y5 2019', 'Y6 2019', 'Y6S', 'Y9 2019', 'Y7P', 'Y9 PRIME 2019', 'P30 LITE', 'P30 LITE 256', 'Y9S', 'P40 LITE', 'NOVA 5T', 'P30', 'P30 PRO',
					]
				},
				{
					name: 'Motorola', devicesOpts: [
						'MOTO E5 PLAY', 'MOTO E6 PLAY', 'MOTO E5', 'MOTO E5 PLUS', 'MOTO G7 PLAY', 'MOTO E6S', 'MOTO E6 PLUS', 'MOTO G8 POWER LITE', 'MOTO G6 PLAY', 'MOTO G7 POWER', 'MOTO G8 PLAY',
						'MOTO ONE', 'MOTO G7', 'MOTO G6 PLUS', 'MOTO 68 POWER', 'MOTO G7 PLUS', 'MOTO 68 PLUS', 'ONE ACTION HYPER', 'ONE VISION', 'ONE ZOOM', 'LEX L11A',
					]
				},
				{
					name: 'Nokia', devicesOpts: [
						'2', '1 PLUS', '2.1', '5', '2.1', '5', '3.1', '4.2', '6.1', '7.1', '8', '3.1 PLUS',
					]
				},
				{
					name: 'Samsung', devicesOpts: [
						'GALAXY M10', 'GALAXY A01', 'GALAXY GRAND PRIME+', 'GALAXY J4 CORE ', 'GALAXY A10', 'GALAXY M20', 'GALAXY J4+', 'GALAXY A10S', 'GALAXY J4', 'GALAXY A20', 'GALAXY A20S', 'GALAXY A30', 'GALAXY M30',
						'GALAXY A30S', 'GALAXY A6+', 'GALAXY J8', 'GALAXY A50', 'GALAXY A51', 'GALAXY A70', 'GALAXY A71', 'GALAXY S9', 'GALAXY NOTE 10 LITE', 'GALAXY S10E', 'GALAXY S9 PLUS', 'GALAXY A80', 'GALAXY S10', 'GALAXY S10 +',
						'GALAXY NOTE 10+', 'GALAXY S20', 'GALAXY S20+',
					]
				},
			],
		}
	}
}
</script>